module.exports = __webpack_public_path__ + "static/img/modal_bgen1.b96068d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bgen1.png
// module id = LPMa
// module chunks = 1